import { gql } from '@apollo/client'

export const createSchoolYearMutation = gql`
  mutation CreateSchoolYear($createSchoolYearInput: CreateSchoolYearInput!, $previousYearId: Float!) {
    createSchoolYear(createSchoolYearInput: $createSchoolYearInput, previousYearId: $previousYearId) {
      school_year_id
    }
  }
`

export const updateSchoolYearMutation = gql`
  mutation UpdateSchoolYear($updateSchoolYearInput: UpdateSchoolYearInput!) {
    updateSchoolYear(updateSchoolYearInput: $updateSchoolYearInput) {
      school_year_id
    }
  }
`

export const isAllowedToDisableSchoolYearMidyearQuery = gql`
  query Query($schoolYearId: Int!) {
    isAllowedToDisableSchoolYearMidyear(schoolYearId: $schoolYearId)
  }
`

export const toggleRegionAvailabilityMutation = gql`
  mutation ToggleRegionAvailability($regionId: Float!) {
    toggleRegionAvailable(regionId: $regionId) {
      id
    }
  }
`

export const getSchoolYearsByRegionId = gql`
  query Region($regionId: ID!) {
    region(id: $regionId) {
      is_available
      SchoolYears {
        school_year_id
        date_begin
        date_end
        grades
        diploma_seeking
        birth_date_cut
        special_ed
        special_ed_options
        enrollment_packet
        midyear_application
        midyear_application_close
        midyear_application_open
        testing_preference_title
        testing_preference_description
        opt_out_form_title
        opt_out_form_description
        ScheduleBuilder {
          max_num_periods
          custom_built
          third_party_provider
        }
        schedule
        diploma_seeking
        testing_preference
        schedule_builder_open
        schedule_builder_close
        second_semester_open
        second_semester_close
        midyear_schedule_open
        midyear_schedule_close
        homeroom_resource_open
        homeroom_resource_close
        learning_logs
        learning_logs_first_second_semesters
        reimbursements
        require_software
        direct_orders
        direct_order_open
        direct_order_close
        reimbursement_open
        reimbursement_close
        custom_built_open
        custom_built_close
        reimbursement_custom_built_open
        reimbursement_custom_built_close
        require_software_open
        require_software_close
        third_party_open
        third_party_close
        mid_direct_order_open
        mid_direct_order_close
        mid_reimbursement_open
        mid_reimbursement_close
        mid_custom_built_open
        mid_custom_built_close
        mid_reimbursement_custom_built_open
        mid_reimbursement_custom_built_close
        mid_require_software_open
        mid_require_software_close
        mid_third_party_open
        mid_third_party_close
        IsCurrentYear
        enable_grade_transition
      }
      county_file_name
      county_file_path
      school_district_file_name
      school_district_file_path
    }
  }
`

export const assignStudentToSOEGql = gql`
  mutation AssignStudentToSOE($assignStudentToSoeInput: AssignStudentToSOEInput!) {
    assignStudentToSOE(assignStudentToSOEInput: $assignStudentToSoeInput)
  }
`

export const transferStudentSOEMutation = gql`
  mutation TransferStudentSOE($assignStudentToSoeInput: AssignStudentToSOEInput!) {
    transferStudentSOE(assignStudentToSOEInput: $assignStudentToSoeInput) {
      errorStudentsIds
      successStudentsIds
    }
  }
`

export const updateStateNameMutation = gql`
  mutation UpdateRegion($updateRegionInput: UpdateRegionInput!) {
    updateRegion(updateRegionInput: $updateRegionInput) {
      id
      name
      program
      state_logo
      timezone
    }
  }
`

export const removeCountyInfoByRegionId = gql`
  mutation RemoveCountyInfoByRegionId($regionId: ID!) {
    removeCountyInfoByRegionId(region_id: $regionId)
  }
`

export const removeFileByFileId = gql`
  mutation DeletePacketDocumentFile($fileId: String!) {
    deletePacketDocumentFile(fileId: $fileId) {
      error
      message
      results
    }
  }
`

export const removeSchoolDistrictInfoByRegionId = gql`
  mutation RemoveSchoolDistrictInfoByRegionId($regionId: ID!) {
    removeSchoolDistrictInfoByRegionId(region_id: $regionId)
  }
`

export const diplomaQuestionDataBySchoolYearGql = gql`
  query GetDiplomaQuestion($diplomaQuestionInput: DiplomaQuestionInput!) {
    getDiplomaQuestion(diplomaQuestionInput: $diplomaQuestionInput) {
      school_year_id
      id
      grades
      description
      title
    }
  }
`

export const diplomaQuestionSaveGql = gql`
  mutation SaveDiplomaQuestion($diplomaQuestionInput: DiplomaQuestionInput!) {
    saveDiplomaQuestion(diplomaQuestionInput: $diplomaQuestionInput) {
      school_year_id
      title
      description
      grades
      id
    }
  }
`

export const diplomaQuestionGradeSaveGql = gql`
  mutation SaveDiplomaQuestionGrade($diplomaQuestionInput: DiplomaQuestionInput!) {
    saveDiplomaQuestionGrade(diplomaQuestionInput: $diplomaQuestionInput)
  }
`

export const generateWithdrawalDocumentation = gql`
  mutation generateWithdrawalDocuments($studentId: Int!, $schoolYearId: Int!) {
    generateWithdrawalDocuments(studentId: $studentId, schoolYearId: $schoolYearId)
  }
`
